<script>
export default {
  name: "SectionTitle",
  // Directive handling
  directives: {
    title: {
      mounted(el, binding, vnode) {
        vnode.componentInstance.title = binding.value;
      },
      updated(el, binding, vnode) {
        vnode.componentInstance.title = binding.value;
      },
    },
  },
  props: {
    number: {
      type: [Number, String],
      default: 1,
    },
    // Add explicit title prop
    title: {
      type: String,
      default: "",
    },
  },
};
</script>

<template>
  <div class="section-title">
    <span class="text">{{ number }}. {{ title }}</span>
  </div>
</template>

<style scoped lang="scss">
.section-title {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0;
  padding: 8px 0; /* Optional spacing */

  .text {
    vertical-align: middle;
  }
}
</style>
